var _linearGradient, _clipPath, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 20,
    role: "img",
    "aria-label": "figma",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "figma") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x2: 0,
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbb",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 20,
    rx: 3,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0,
    height: 20,
    fill: "#555"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 59,
    height: 20,
    fill: "#f24e1e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 20,
    fill: "url(#s)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 110
  }, /*#__PURE__*/React.createElement("image", {
    x: 5,
    y: 3,
    width: 14,
    height: 14,
    href: "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJ3aGl0ZSIgcm9sZT0iaW1nIiB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHRpdGxlPkZpZ21hPC90aXRsZT48cGF0aCBkPSJNMTUuODUyIDguOTgxaC00LjU4OFYwaDQuNTg4YzIuNDc2IDAgNC40OSAyLjAxNCA0LjQ5IDQuNDlzLTIuMDE0IDQuNDkxLTQuNDkgNC40OTF6TTEyLjczNSA3LjUxaDMuMTE3YzEuNjY1IDAgMy4wMTktMS4zNTUgMy4wMTktMy4wMTlzLTEuMzU1LTMuMDE5LTMuMDE5LTMuMDE5aC0zLjExN1Y3LjUxem0wIDEuNDcxSDguMTQ4Yy0yLjQ3NiAwLTQuNDktMi4wMTQtNC40OS00LjQ5UzUuNjcyIDAgOC4xNDggMGg0LjU4OHY4Ljk4MXptLTQuNTg3LTcuNTFjLTEuNjY1IDAtMy4wMTkgMS4zNTUtMy4wMTkgMy4wMTlzMS4zNTQgMy4wMiAzLjAxOSAzLjAyaDMuMTE3VjEuNDcxSDguMTQ4em00LjU4NyAxNS4wMTlIOC4xNDhjLTIuNDc2IDAtNC40OS0yLjAxNC00LjQ5LTQuNDlzMi4wMTQtNC40OSA0LjQ5LTQuNDloNC41ODh2OC45OHpNOC4xNDggOC45ODFjLTEuNjY1IDAtMy4wMTkgMS4zNTUtMy4wMTkgMy4wMTlzMS4zNTUgMy4wMTkgMy4wMTkgMy4wMTloMy4xMTdWOC45ODFIOC4xNDh6TTguMTcyIDI0Yy0yLjQ4OSAwLTQuNTE1LTIuMDE0LTQuNTE1LTQuNDlzMi4wMTQtNC40OSA0LjQ5LTQuNDloNC41ODh2NC40NDFjMCAyLjUwMy0yLjA0NyA0LjUzOS00LjU2MyA0LjUzOXptLS4wMjQtNy41MWEzLjAyMyAzLjAyMyAwIDAgMC0zLjAxOSAzLjAxOWMwIDEuNjY1IDEuMzY1IDMuMDE5IDMuMDQ0IDMuMDE5IDEuNzA1IDAgMy4wOTMtMS4zNzYgMy4wOTMtMy4wNjh2LTIuOTdIOC4xNDh6bTcuNzA0IDBoLS4wOThjLTIuNDc2IDAtNC40OS0yLjAxNC00LjQ5LTQuNDlzMi4wMTQtNC40OSA0LjQ5LTQuNDloLjA5OGMyLjQ3NiAwIDQuNDkgMi4wMTQgNC40OSA0LjQ5cy0yLjAxNCA0LjQ5LTQuNDkgNC40OXptLS4wOTctNy41MDljLTEuNjY1IDAtMy4wMTkgMS4zNTUtMy4wMTkgMy4wMTlzMS4zNTUgMy4wMTkgMy4wMTkgMy4wMTloLjA5OGMxLjY2NSAwIDMuMDE5LTEuMzU1IDMuMDE5LTMuMDE5cy0xLjM1NS0zLjAxOS0zLjAxOS0zLjAxOWgtLjA5OHoiLz48L3N2Zz4="
  }), /*#__PURE__*/React.createElement("text", {
    "aria-hidden": "true",
    x: 385,
    y: 150,
    fill: "#010101",
    fillOpacity: 0.3,
    transform: "scale(.1)",
    textLength: 310
  }, "figma"), /*#__PURE__*/React.createElement("text", {
    x: 385,
    y: 140,
    transform: "scale(.1)",
    fill: "#fff",
    textLength: 310
  }, "figma"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.708864b2849ddc9021ab6afbf38c9ce8.svg";
export { ForwardRef as ReactComponent };